export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/teradata.9b1cf47.svg";